export const creators = [
  {
    id: 1,
    slug: "tianlizi",
    name: "甜栗子",
    handle: "@tianlizi",
    platform: "抖音",
    category: "美妆护肤",
    categorySlug: "beauty",
    title: "从宿舍自拍到妆造全开，甜栗子的六年面容进化",
    beforeYear: 2019,
    afterYear: 2025,
    contrastScore: 92,
    heat: 98,
    fans: "860万",
    tags: ["妆容进化", "气场全开", "校园素人"],
    summary:
      "2019 年的她还是宿舍里对着手机前置随手一拍的女生，马尾、素颜、灰卫衣是当时的标配。六年过去，她的妆面结构和镜头控制力已经完全换了一套逻辑，最明显的变化是眉形从圆钝走向利落，整个人的锐度被提了上来。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20shy%20college%20girl%20with%20plain%20ponytail%20and%20no%20makeup%2C%20wearing%20simple%20grey%20hoodie%2C%20holding%20phone%20selfie%20angle%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-tianlizi-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20confident%20polished%20beauty%20influencer%20with%20sleek%20styled%20hair%20and%20refined%20makeup%2C%20wearing%20elegant%20terracotta%20blazer%2C%20studio%20three%20point%20lighting%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-tianlizi-after&orientation=portrait",
    timeline: [
      { year: 2019, title: "宿舍自拍期", desc: "前置摄像头直出，不打光不修图，内容以日常碎片为主。" },
      { year: 2021, title: "妆面启蒙", desc: "开始系统学习底妆与眉形，视频里第一次出现补光灯。" },
      { year: 2023, title: "风格定型", desc: "确认走轻欧美路线，轮廓修容成为她的辨识度。" },
      { year: 2025, title: "团队化作业", desc: "妆造、灯光、后期成体系，单条内容都是完整企划。" },
    ],
  },
  {
    id: 2,
    slug: "haiyankeke",
    name: "海盐可可",
    handle: "@haiyankeke",
    platform: "小红书",
    category: "穿搭时尚",
    categorySlug: "fashion",
    title: "宽大牛仔到廓形大衣，海盐可可的穿搭落地史",
    beforeYear: 2018,
    afterYear: 2025,
    contrastScore: 88,
    heat: 95,
    fans: "520万",
    tags: ["廓形升级", "配色进阶", "街拍感"],
    summary:
      "她早期的穿搭很好认：一件洗到发白的宽大牛仔外套配旧球鞋。后来她把预算几乎全投在面料和剪裁上，同一张脸，靠结构感大衣和层次叠穿完成了气质的整体上移。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20casual%20young%20woman%20in%20oversized%20washed%20denim%20jacket%20and%20plain%20sneakers%2C%20unstyled%20short%20hair%2C%20standing%20on%20plain%20street%20background%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-haiyankeke-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20stylish%20fashion%20editor%20wearing%20tailored%20camel%20coat%20with%20layered%20accessories%2C%20glossy%20waved%20hair%2C%20confident%20runway%20pose%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-haiyankeke-after&orientation=portrait",
    timeline: [
      { year: 2018, title: "大学生穿搭", desc: "以平价单品为主，主打实用不出错的日常搭配。" },
      { year: 2020, title: "找对比例", desc: "开始研究腰线与廓形，画面里的重心逐渐清晰。" },
      { year: 2022, title: "配色重塑", desc: "砍掉高饱和单品，转向驼、墨、灰的克制配色。" },
      { year: 2025, title: "街拍成熟", desc: "造型与拍摄同步升级，整组图有了杂志感。" },
    ],
  },
  {
    id: 3,
    slug: "juziqishui",
    name: "橘子汽水",
    handle: "@juziqishui",
    platform: "B站",
    category: "美食探店",
    categorySlug: "food",
    title: "出租屋厨房到专业棚拍，橘子汽水的松弛感养成",
    beforeYear: 2020,
    afterYear: 2025,
    contrastScore: 74,
    heat: 90,
    fans: "310万",
    tags: ["氛围感", "画面升级", "松弛感"],
    summary:
      "做美食内容的人，脸的变化往往被食物挡住，可她的变化全写在状态里。早期在出租屋厨房里紧张到手抖，现在对着镜头吃饭聊天都能自然接梗，这种松弛是时间给的。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20an%20ordinary%20young%20food%20vlogger%20in%20simple%20striped%20tee%20holding%20a%20bowl%2C%20plain%20home%20kitchen%20backdrop%20simplified%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-juziqishui-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20relaxed%20professional%20food%20creator%20in%20linen%20apron%20over%20crisp%20shirt%2C%20warm%20smile%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-juziqishui-after&orientation=portrait",
    timeline: [
      { year: 2020, title: "出租屋开更", desc: "一台手机加一口锅，画面晃动，语速偏快。" },
      { year: 2022, title: "设备换新", desc: "补光与收音到位，开始有固定的开场设计。" },
      { year: 2023, title: "风格转型", desc: "从测评转向慢节奏探店，讲话方式明显放缓。" },
      { year: 2025, title: "人设稳定", desc: "造型与场景统一，观众记住的是她的松弛状态。" },
    ],
  },
  {
    id: 4,
    slug: "ayenight",
    name: "阿夜 NIGHT",
    handle: "@ayenight",
    platform: "抖音",
    category: "剧情搞笑",
    categorySlug: "comedy",
    title: "校服寸头到角色控场，阿夜的气场是怎么练的",
    beforeYear: 2017,
    afterYear: 2025,
    contrastScore: 86,
    heat: 93,
    fans: "1240万",
    tags: ["气场反差", "角色切换", "造型进阶"],
    summary:
      "翻他 2017 年的视频，还是留着锅盖头、穿着黑 T 硬演段子的高中生。八年之后同一个人站在镜头前，靠一个眼神就能把全场节奏拿住，这种变化更像是表演能力外溢到了外形上。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20teenage%20boy%20with%20messy%20bowl%20cut%20hair%20wearing%20plain%20black%20tee%2C%20awkward%20straight%20faced%20expression%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-ayenight-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20sharp%20styled%20young%20male%20comedy%20creator%20with%20undercut%20haircut%20and%20olive%20green%20bomber%20jacket%2C%20charismatic%20expression%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-ayenight-after&orientation=portrait",
    timeline: [
      { year: 2017, title: "学生段子手", desc: "校服加身，靠夸张表情撑起整条内容。" },
      { year: 2019, title: "短发转型", desc: "剪短头发之后五官被露出来，辨识度明显提高。" },
      { year: 2022, title: "角色拓宽", desc: "开始一人分饰多角，造型切换变成核心看点。" },
      { year: 2025, title: "控场成熟", desc: "节奏、台词与视觉风格统一，气场成了招牌。" },
    ],
  },
  {
    id: 5,
    slug: "shiguang",
    name: "拾光少女",
    handle: "@shiguang",
    platform: "小红书",
    category: "旅行户外",
    categorySlug: "travel",
    title: "游客照到人像大片，拾光少女的构图觉醒",
    beforeYear: 2019,
    afterYear: 2025,
    contrastScore: 81,
    heat: 88,
    fans: "260万",
    tags: ["构图进化", "色调统一", "旅行感"],
    summary:
      "她最早的旅行照是标准的到此一游，逆光、糊焦、随手一拍。现在她的图统一在低饱和暖调里，人站在画面三分线上，连衣服颜色都和背景提前商量好了。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20young%20traveler%20in%20plain%20windbreaker%20with%20cheap%20backpack%2C%20messy%20windblown%20hair%2C%20flat%20mountain%20silhouette%20simplified%20behind%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-shiguang-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20an%20elegant%20travel%20creator%20in%20flowy%20cream%20trench%20coat%20with%20wide%20brim%20hat%2C%20editorial%20outdoor%20pose%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-shiguang-after&orientation=portrait",
    timeline: [
      { year: 2019, title: "背包穷游", desc: "以记录路线为主，照片多为随手抓拍。" },
      { year: 2021, title: "开始构图", desc: "系统学习三分法与引导线，出片率明显上升。" },
      { year: 2023, title: "色调统一", desc: "整组内容锁定暖沙色调，形成个人视觉签名。" },
      { year: 2025, title: "人像成熟", desc: "从记录风景变成经营画面，人物成为叙事中心。" },
    ],
  },
  {
    id: 6,
    slug: "laozhou",
    name: "老周说书",
    handle: "@laozhoushuoshu",
    platform: "B站",
    category: "知识科普",
    categorySlug: "knowledge",
    title: "合租房到书房棚，老周说书的气质沉淀",
    beforeYear: 2016,
    afterYear: 2025,
    contrastScore: 68,
    heat: 84,
    fans: "430万",
    tags: ["气质沉淀", "场景升级", "书卷气"],
    summary:
      "他的变化不算剧烈，却是最能说明问题的一类。同一副金丝眼镜，从出租屋的灰毛衣换到了书墙前的墨绿针织衫，人没什么大改，可信度却完全不同了。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20middle%20aged%20man%20in%20plain%20grey%20sweater%20sitting%20in%20simple%20rented%20room%20background%20simplified%2C%20thin%20glasses%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-laozhou-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20distinguished%20knowledge%20host%20in%20deep%20green%20knit%20polo%20behind%20a%20tidy%20studio%20desk%20with%20books%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-laozhou-after&orientation=portrait",
    timeline: [
      { year: 2016, title: "合租房开讲", desc: "背景是白墙与晾衣架，靠内容本身撑场。" },
      { year: 2019, title: "书墙登场", desc: "搬进独立书房，画面开始有了知识区的样子。" },
      { year: 2022, title: "形象整理", desc: "固定眼镜与针织衫组合，减少观众的视觉干扰。" },
      { year: 2025, title: "气质稳定", desc: "服装、灯光、节奏全部收敛成稳定的讲述感。" },
    ],
  },
  {
    id: 7,
    slug: "shanye",
    name: "山野阿栗",
    handle: "@shanyeyali",
    platform: "抖音",
    category: "健身运动",
    categorySlug: "fitness",
    title: "驼背瘦子到挺立状态，山野阿栗的体态重建",
    beforeYear: 2018,
    afterYear: 2025,
    contrastScore: 90,
    heat: 91,
    fans: "380万",
    tags: ["体态重建", "精神面貌", "长期主义"],
    summary:
      "这是本站里最实打实的一组对比。七年时间，他从含胸驼背的瘦高个练到站姿挺拔，脸没动过，但整个人的精气神换了一副骨架撑着。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20skinny%20young%20man%20in%20loose%20tank%20top%20with%20slightly%20hunched%20posture%2C%20simple%20gym%20background%20simplified%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-shanye-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20an%20athletic%20fitness%20creator%20in%20fitted%20dark%20tee%20with%20healthy%20muscular%20build%2C%20upright%20confident%20stance%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-shanye-after&orientation=portrait",
    timeline: [
      { year: 2018, title: "从零开始", desc: "体重偏轻、体态塌陷，训练从最基础的动作学起。" },
      { year: 2020, title: "体态矫正", desc: "把重点放在肩颈与核心，站姿先有了变化。" },
      { year: 2023, title: "形体建立", desc: "肌肉量上来之后，整个人的轮廓开始清晰。" },
      { year: 2025, title: "状态稳定", desc: "训练成为日常，精神面貌是最直观的收获。" },
    ],
  },
  {
    id: 8,
    slug: "baitao",
    name: "白桃乌龙",
    handle: "@baitaowulong",
    platform: "小红书",
    category: "美妆护肤",
    categorySlug: "beauty",
    title: "学生气到清透挂，白桃乌龙的妆面减法",
    beforeYear: 2021,
    afterYear: 2025,
    contrastScore: 77,
    heat: 87,
    fans: "190万",
    tags: ["妆面减法", "清透路线", "审美升级"],
    summary:
      "和大多数人的加法路线相反，她走的是减法。刘海留长露出额头，妆容从堆叠色彩改成清透底妆，反而把原本被压住的五官优势全部释放了出来。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20teenage%20girl%20with%20round%20face%20and%20blunt%20bangs%2C%20wearing%20school%20uniform%20style%20cardigan%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-baitao-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20delicate%20makeup%20artist%20with%20soft%20peach%20toned%20glow%20makeup%20and%20elegant%20updo%2C%20wearing%20silk%20blouse%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-baitao-after&orientation=portrait",
    timeline: [
      { year: 2021, title: "齐刘海时期", desc: "学生妆为主，腮红与眼影偏重，风格还算稚嫩。" },
      { year: 2023, title: "留长刘海", desc: "露出额头后五官比例被重新认识，轮廓更舒展。" },
      { year: 2024, title: "妆面减法", desc: "减少色彩堆叠，把重心放到底妆质感与眉形。" },
      { year: 2025, title: "风格清晰", desc: "清透挂路线彻底定型，成为她的内容标识。" },
    ],
  },
  {
    id: 9,
    slug: "maodou",
    name: "毛豆先生",
    handle: "@maodouxiansheng",
    platform: "B站",
    category: "数码科技",
    categorySlug: "digital",
    title: "出租屋桌角到专业演播位，毛豆先生的画面革命",
    beforeYear: 2017,
    afterYear: 2025,
    contrastScore: 71,
    heat: 80,
    fans: "350万",
    tags: ["状态升级", "画面革命", "专业感"],
    summary:
      "做数码内容的人最容易被设备暴露年代。他早期在出租屋桌角用手机支架拍，光打得人脸发灰；如今同一个人坐在专业灯位前，衬衫平整，眼神里都是笃定。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20young%20tech%20reviewer%20in%20wrinkled%20plaid%20shirt%20filming%20with%20a%20cheap%20phone%20tripod%20in%20a%20cramped%20desk%20corner%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-maodou-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20professional%20tech%20presenter%20in%20minimal%20charcoal%20shirt%20with%20studio%20softbox%20rig%20behind%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-maodou-after&orientation=portrait",
    timeline: [
      { year: 2017, title: "桌角开机", desc: "设备简陋，光线靠台灯硬撑，画面发灰。" },
      { year: 2019, title: "入门布光", desc: "添置第一盏柔光灯，脸部质感立刻改善。" },
      { year: 2022, title: "形象打理", desc: "固定衬衫与发型，减少观众对个人造型的注意。" },
      { year: 2025, title: "演播成熟", desc: "从背景到着装形成完整视觉，专业感拉满。" },
    ],
  },
  {
    id: 10,
    slug: "yikeqingning",
    name: "一颗青柠",
    handle: "@yikeqingning",
    platform: "小红书",
    category: "穿搭时尚",
    categorySlug: "fashion",
    title: "白衬衫素人到极简博主，一颗青柠的审美重塑",
    beforeYear: 2020,
    afterYear: 2025,
    contrastScore: 84,
    heat: 86,
    fans: "210万",
    tags: ["极简路线", "审美重塑", "配色克制"],
    summary:
      "她的转折点发生在 2022 年，把衣柜里所有花色单品清空，只留下米、驼、黑白。同一张脸在极简配色和利落版型里，突然就变得很有说服力。",
    beforeImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20plain%20high%20school%20girl%20in%20simple%20white%20shirt%20with%20no%20styling%2C%20shy%20neutral%20expression%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20muted%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20soft%20natural%20light%2C%20high%20detail&width=700&height=900&seq=fc-yikeqingning-before&orientation=portrait",
    afterImage:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20portrait%20of%20a%20chic%20minimal%20style%20blogger%20in%20monochrome%20beige%20knit%20set%20with%20gold%20jewelry%2C%20editorial%20pose%2C%20warm%20cream%20background%2C%20editorial%20magazine%20illustration%20style%2C%20warm%20earthy%20palette%2C%20centered%20composition%2C%20clean%20minimal%20shapes%2C%20high%20detail&width=700&height=900&seq=fc-yikeqingning-after&orientation=portrait",
    timeline: [
      { year: 2020, title: "素人起步", desc: "白衬衫配牛仔，内容以日常随拍为主。" },
      { year: 2021, title: "试错阶段", desc: "尝试过多种风格，画面配色一度非常杂乱。" },
      { year: 2022, title: "衣柜清空", desc: "只保留低饱和色系，造型逻辑彻底重构。" },
      { year: 2025, title: "极简定型", desc: "版型与配色固定下来，内容辨识度大幅提升。" },
    ],
  },
];

export const platformOptions = ["全部平台", "抖音", "小红书", "B站"];

export const sortOptions = [
  { value: "heat", label: "按热度排序" },
  { value: "contrast", label: "按反差指数排序" },
  { value: "recent", label: "按最近更新排序" },
];

export const siteStats = [
  { value: "312", label: "已收录对比对象", suffix: "位" },
  { value: "1874", label: "对比组图", suffix: "组" },
  { value: "26万", label: "月均查阅人次", suffix: "" },
  { value: "4.8", label: "读者满意度", suffix: "分" },
];